import React from 'react';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';

import Page from '@feathr/extender/App/Page';
import { useLocalUrl } from '@feathr/extender/state';

interface ILocationState {
  from: {
    pathname: string;
  };
}

function NotFound() {
  const location = useLocation<ILocationState>();
  const localUrl = useLocalUrl();
  return (
    <Page title={"Sorry, that page doesn't exist."}>
      {location && location.state && location.state.from && (
        <p>
          You were trying to visit <em>{location.state.from.pathname}</em>.
        </p>
      )}
      <p>
        You might find what you were looking for in the&nbsp;
        <Link to={localUrl('/projects')}>projects section</Link> or the&nbsp;
        <Link to={localUrl('/data/explore/people')}>data section</Link>.
      </p>
    </Page>
  );
}

export default NotFound;
